import {
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { productStatusMonitoringApiRef } from './apis';

export const productStatusMonitoringPlugin = createFrontendPlugin({
  extensions: [
    TrpcApiBlueprint.make({
      name: 'product-status-monitoring',
      params: defineParams =>
        defineParams({
          apiRef: productStatusMonitoringApiRef,
          path: 'product-status-monitoring',
        }),
    }),
  ],
  pluginId: 'product-status-monitoring',
});
